import { createSelector } from '@reduxjs/toolkit';
import { AppState } from 'store';

export const isLoadingSlice = (state: AppState) => state.grazingHeatmap.loading;
export const metricsForAllFarmsSlice = (state: AppState) => state.grazingHeatmap.metricsForAllFarms;

export const isLoading = createSelector(isLoadingSlice, (state) => state);

export const metricsForAllFarms = createSelector(metricsForAllFarmsSlice, (state) => state);
